import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Heading1, Heading3 } from '../../design-system/headings';
import DefaultTrans from '../default-i18next-trans';

export const Question = observer(({ ui }) => {
    const { t } = useTranslation('assessment');

    return (
        <div className="assessment-presentation">
            <div className="question">
                <Heading1 mb={8}>{t(ui.title)} </Heading1>
                <DefaultTrans translatedString={t(ui.description)} />
                {ui.password && (
                    <div className="password">{t(ui.password)}</div>
                )}
                {ui.pretitle && <Heading3>{t(ui.pretitle)}</Heading3>}
            </div>
        </div>
    );
});
